module.exports = __webpack_public_path__ + "static/media/left-white-arrow.000ed83d.svg";